/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function makeVideoChat(options, context) {
    var _a;
    // 该api需要钉钉鉴权：https://open.dingtalk.com/document/orgapp/initiate-video-conference
    var api = 'dd.biz.conference.videoConfCall';
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options);
}

export { makeVideoChat as default };
